import { render, staticRenderFns } from "./CN.vue?vue&type=template&id=f8d3b052&scoped=true"
import script from "./CN.vue?vue&type=script&lang=js"
export * from "./CN.vue?vue&type=script&lang=js"
import style0 from "./CN.vue?vue&type=style&index=0&id=f8d3b052&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3b052",
  null
  
)

export default component.exports